import axios from 'axios'
import { addSeconds } from '../utils/date.js'

function getPortseaApiClient(baseUrl) {
  const client = axios.create({
    baseURL: baseUrl
  })
  client.interceptors.request.use(
    config => {
      return authorize().then(res => {
        // read our token information from local storage
        if (config.method === 'get') {
          config.params = config.params || {}
          config.params.bearer_token = res.access_token
        } else {
          config.headers.Authorization = `${res.token_type} ${res.access_token}`
        }
        return Promise.resolve(config)
      })
    },
    error => Promise.reject(error)
  )

  return client
}

export function getEngineApiClient() {
  return getPortseaApiClient(process.env.VUE_APP_ENGINE_API_BASE_URL)
}

export function encodeArrayAsQueryString(array, parameterName) {
  let result = ''

  for (let i = 0; i < array.length; i++) {
    result += `${parameterName}[${i}]=${array[i]}&`
  }

  return result.substring(0, result.length - 1)
}

function getAuthorizationClient() {
  const client = axios.create({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  return client
}

function authorize() {
  // get token meta from local storage
  const accessToken = sessionStorage.getItem('access_token')
  const tokenType = sessionStorage.getItem('token_type')
  const tokenExpires = new Date(sessionStorage.getItem('token_expires'))

  const expiryPivot = addSeconds(Date.now(), 60)

  // check we got token meta and the token has not expired or is about to expire
  if (
    accessToken == null ||
    tokenType == null ||
    tokenExpires == null ||
    tokenExpires < expiryPivot
  ) {
    // authorize if no token available
    const authClient = getAuthorizationClient()

    // setup the query parameters
    const params = new URLSearchParams()
    params.append('grant_type', 'client_credentials')
    params.append('client_id', process.env.VUE_APP_AUTH_CLIENT_ID)
    params.append('client_secret', process.env.VUE_APP_AUTH_CLIENT_SECRET)

    return authClient
      .post(process.env.VUE_APP_AUTH_TOKEN_URL, params)
      .then(res => {
        // store the values for our next authorisation attempt
        sessionStorage.setItem('access_token', res.data.access_token)
        sessionStorage.setItem(
          'token_expires',
          addSeconds(Date.now(), res.data.expires_in)
        )
        sessionStorage.setItem('token_type', res.data.token_type)

        return {
          access_token: res.data.access_token,
          token_type: res.data.token_type
        }
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  // no authorisation to do - return our promise anyway
  return new Promise(resolve => {
    resolve({
      access_token: accessToken,
      token_type: tokenType
    })
  })
}
